import moment from "moment";
import { FilterManager } from "@search";
import { Filter, initialFilter } from "./utils";

export class SharedFileFilterManager extends FilterManager<Filter> {
  isFilterDirty(key: keyof Filter): boolean {
    if (key === "from" || key === "to") {
      return !moment(this.filter[key]).isSame(initialFilter[key]);
    }

    return super.isFilterDirty(key);
  }
}
